import { APPLICATION_FETCHED, TOGGLE_NOTIFICATION, TOGGLE_SPINNER } from "utils/constants";
import asyncDispatcher from 'utils/asyncDispatcher';
import { fetchXeroSnapshotByOrgId } from 'actions/xero';
import { toggleSpinner } from 'actions/commonActions';

const dispatchApplication = (dispatch) => (data) => {
  return dispatch({
    type: APPLICATION_FETCHED,
    data: { application: data.application || data }
  });
}

export const fetchApplication = (appNumber) => (dispatch, getState) => {
  const { api } = getState().app;

  api.fetchApplication(appNumber)
    .then(dispatchApplication(dispatch));
}

export const fetchApplicationAndXeroSnapshot = (appNumber) => (dispatch, getState) => {
  const { api } = getState().app;

  api.fetchApplication(appNumber)
    .then(dispatchApplication(dispatch))
    .then(resp => {
      if (resp.data.application && resp.data.application.appType === 'xero') {
        dispatch(fetchXeroSnapshotByOrgId(resp.data.application.organisationId));
      }
    });
}

export const fetchApplications = () => (dispatch, getState) => {
  const { api } = getState().app;

  dispatch(toggleSpinner());

  return api.fetchApplications()
    .then((data) => {
      data.applications.forEach(dispatchApplication(dispatch));
      dispatch(toggleSpinner());
    });
}

export const submitApplication = (appNumber) => (dispatch, getState) => {
  const { api } = getState().app;
  const notificationMsg = 'Application updated successfully';
  return asyncDispatcher(dispatch, {
    action: api.submitApplication(
      appNumber, getState().form.applicationForm.values
    ),
    data: { notificationMsg },
    pending: TOGGLE_SPINNER,
    success: [TOGGLE_NOTIFICATION, APPLICATION_FETCHED],
    failure: TOGGLE_NOTIFICATION,
  });
}

export const approveApplication = (appNumber) => (dispatch, getState) => {
  const { api } = getState().app;
  const notificationMsg = 'Application approved! A contract will be sent to the customer.';
  return asyncDispatcher(dispatch, {
    action: api.approveApplication(appNumber),
    data: { notificationMsg },
    pending: TOGGLE_SPINNER,
    success: [TOGGLE_NOTIFICATION, APPLICATION_FETCHED],
    failure: TOGGLE_NOTIFICATION,
  });
}

export const rejectApplication = (appNumber) => (dispatch, getState) => {
  const { api } = getState().app;
  const notificationMsg = 'Application rejected!';
  return asyncDispatcher(dispatch, {
    action: api.rejectApplication(appNumber),
    data: { notificationMsg },
    pending: TOGGLE_SPINNER,
    success: [TOGGLE_NOTIFICATION, APPLICATION_FETCHED],
    failure: TOGGLE_NOTIFICATION,
  });
}

export const authorizeApplication = ({appNumber, authorized}) => (dispatch, getState) => {
  const { api } = getState().app;
  const notificationMsg = 'Application updated!';
  return asyncDispatcher(dispatch, {
    action: api.authorizeApplication({appNumber, authorized}),
    data: { notificationMsg },
    pending: TOGGLE_SPINNER,
    success: [TOGGLE_NOTIFICATION, APPLICATION_FETCHED],
    failure: TOGGLE_NOTIFICATION,
  });
}

export const createOrgFromApp = (applicationNumber) => (dispatch, getState) => {
  const { api } = getState().app;

  return api.createOrganisation({applicationNumber: applicationNumber})
    .then(resp => {
      dispatch(fetchApplication(applicationNumber))
    });
}

export const requestDoc = (applicationNumber, docs) => (dispatch, getState) => {
  const { api } = getState().app;
  dispatch(toggleSpinner());

  return api.requestDoc(applicationNumber, docs)
    .then(resp => {
      dispatch(fetchApplication(applicationNumber))
      dispatch(toggleSpinner());
    });
}



// WEBPACK FOOTER //
// ./src/actions/applications.js